"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllApps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const uuid_1 = require("uuid");
const react_i18next_1 = require("react-i18next");
const app_card_1 = require("../../../components/app-card");
const app_card_skeleton_1 = require("../../../components/app-card/app-card-skeleton");
const all_apps_module_css_1 = __importDefault(require("./all-apps.module.css"));
const AllApps = ({ isTg, selectedLanguage, data, isLoading }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: all_apps_module_css_1.default.allApps, children: [(0, jsx_runtime_1.jsx)("div", { className: all_apps_module_css_1.default.allAppsTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h4", className: all_apps_module_css_1.default.allAppsTitle, children: t('common.all-apps') }) }), (0, jsx_runtime_1.jsx)("div", { className: all_apps_module_css_1.default.allAppsItems, children: isLoading
                    ? Array(4).fill(null).map(_ => (0, jsx_runtime_1.jsx)(app_card_skeleton_1.AppCardSkeleton, {}, (0, uuid_1.v1)()))
                    : data?.map(el => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(app_card_1.AppCard, { isTg: isTg, ...el }, (0, uuid_1.v1)()) }, (0, uuid_1.v1)()))) })] }));
};
exports.AllApps = AllApps;
